import { render } from "./media-text-split.vue?vue&type=template&id=afd4177c"
import script from "./media-text-split.vue?vue&type=script&lang=js"
export * from "./media-text-split.vue?vue&type=script&lang=js"

import "./media-text-split.vue?vue&type=style&index=0&id=afd4177c&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__